import { useDialog } from '@wheely/ui-kit';
import { FormattedMessage } from 'react-intl';

import { ReportSentDialog } from './ReportSentDialog';
import s from './styles.module.css';

const useReportSentDialog = () => {
  const { openDialog } = useDialog();

  const openModal = ({ email }: { email: string }) =>
    openDialog(({ onClose }) => <ReportSentDialog email={email} onClose={onClose} />, {
      title: (
        <FormattedMessage
          defaultMessage="You will receive report by your email"
          id="9bY7Ax"
          description="Dialog title"
        />
      ),
      className: s.dialog,
      titleClassName: s.title,
      bodyClassName: s.bodyWrapper,
    });

  return { openModal };
};

export { useReportSentDialog };
